import simpleView from './simpleView'

const headers =
{
    simpleView
};

export default headers ;
